import { render } from "./Gift.view.vue?vue&type=template&id=585f417c"
import script from "./Gift.view.vue?vue&type=script&lang=js"
export * from "./Gift.view.vue?vue&type=script&lang=js"

import "./Gift.view.vue?vue&type=style&index=0&id=585f417c&lang=scss"
script.render = render

export default script